const REMEMBER_SESSION_UNTIL_KEY = 'remember_session_until';
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

export const setRememberSessionFor30Days = () => {
  if (typeof window === 'undefined') return;
  const expiresAt = Date.now() + THIRTY_DAYS_MS;
  localStorage.setItem(REMEMBER_SESSION_UNTIL_KEY, String(expiresAt));
};

export const clearRememberSessionWindow = () => {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(REMEMBER_SESSION_UNTIL_KEY);
};

export const isRememberSessionExpired = () => {
  if (typeof window === 'undefined') return false;

  const raw = localStorage.getItem(REMEMBER_SESSION_UNTIL_KEY);
  if (!raw) return false;

  const expiresAt = Number(raw);
  if (!Number.isFinite(expiresAt)) {
    localStorage.removeItem(REMEMBER_SESSION_UNTIL_KEY);
    return false;
  }

  return Date.now() > expiresAt;
};
